// @ts-check
/* global gtag, umami */

/**
 * IntersectionObserver based Scroll Depth
 */
function scrollDepthTracker(waypoints = 4) {
  /**
   * depths will be an array of fractional floating point values up to 1.0
   * with waypoints set to its default 4, values will be [0.25, 0.5, 0.75, 1]
   * with waypoints set to 5, values will be [0.2, 0.4, 0.6, 0.8, 1]
   * with waypoints set to 6, values will be [0.17, 0.33, 0.5, 0.67, 0.83, 1]
   */
  const depths = Array(waypoints)
    .fill(waypoints)
    .map((n, i) => (i + 1) / n);

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let label = "Scroll Depth " + entry.target.dataset.depth;
        console.log(label);

        if (typeof gtag !== "undefined") {
          gtag("event", "Scroll Depth", {
            event_category: "Scroll Depth Percentage",
            event_label: label,
            non_interaction: true,
          });
          window.eventTrackerActive = true;
        }

        if (window.umami && umami.track) {
          // new scroll-depth event with additional data attached
          umami.track("scroll", {
            data: {
              pathname: window.location.pathname,
              title: document.title,
              depth: entry.target.dataset.depth,
              time: Math.round(entry.time), // time elapsed in ms
            },
          });
          // old-style event with depth in event label
          // TODO: disable this if new events are enough
          umami.track(label, {
            data: {
              pathname: window.location.pathname,
              title: document.title,
              depth: entry.target.dataset.depth,
              time: Math.round(entry.time), // time elapsed in ms
            },
          });

          window.eventTrackerActive = true;
        }

        /**
         * Remove observer if EITHER analytics library has loaded and is collecting data
         *
         * TODO: This could lose data if one library loads significantly faster than the other
         */
        if (window.eventTrackerActive === true) {
          observer.unobserve(entry.target);
        }
      }
    });
  };

  const percent = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 2,
  }).format;

  const observer = new IntersectionObserver(observerCallback);

  depths.forEach((depth) => {
    const marker = document.createElement("i");
    const depthPercent = percent(depth);

    marker.dataset.depth = depthPercent;
    marker.style.position = "absolute";
    marker.style.top = depthPercent;
    marker.style.marginTop = "-1px";
    marker.style.zIndex = "-1";

    // debug class
    marker.className = `iop_depth_marker iop_depth_${depthPercent}`;

    document.body.appendChild(marker);
    observer.observe(marker);
  });
}

window.addEventListener("DOMContentLoaded", () => scrollDepthTracker());
